import { render } from "./IconReject.vue?vue&type=template&id=b8562e42"
const script = {}
script.render = render

export default script